export const constants = {
	home: "home",
	login: "login",
	verify: "verify",
	register: "register",
	resend: "resend",
	reset: "reset",
	school: "school",
	programmes: "programmes",
	students: "students",
	letter: "letter",
	fees: "fees",
	admin: "admin",
	transfers: "transfers",
	clients: "clients",
	trainings: "trainings",
	profile: "Profile",
	changePassword: "Change Password",
	academics: "academics",
	courseRegistrationSetups: "course-registration-setup",
	courseRegistration: "course-registration",
};

export const regions = [
	{ label: "Ashanti", value: "Ashanti" },
	{ label: "Greater Accra", value: "Greater Accra" },
	{ label: "Northern", value: "Northern" },
	{ label: "Western", value: "Western" },
	{ label: "Volta", value: "Volta" },
	{ label: "Upper East", value: "Upper East" },
	{ label: "Central", value: "Central" },
	{ label: "Eastern", value: "Eastern" },
	{ label: "Upper West", value: "Upper West" },
	{ label: "Brong Ahafo", value: "Brong Ahafo" },
	{ label: "Bono East", value: "Bono East" },
	{ label: "Ahafo", value: "Ahafo" },
	{ label: "North East", value: "North East" },
	{ label: "Oti", value: "Oti" },
	{ label: "Savannah", value: "Savannah" },
	{ label: "Western North", value: "Western North" },
];

// The academic year rolls over in September (month index 8), matching
// getCurrentAcademicYears() in helpers/functions.
const FIRST_ACADEMIC_YEAR = 2019;
const FIRST_YEAR = 2021;

const currentAcademicStartYear = () => {
	const now = new Date();
	return now.getMonth() >= 8 ? now.getFullYear() : now.getFullYear() - 1;
};

const range = (from: number, to: number) => {
	const list: number[] = [];
	for (let year = from; year <= to; year++) {
		list.push(year);
	}
	return list;
};

// Generated so the current academic year is always an option, without
// having to extend a hard-coded list every September.
export const academicYears = range(
	FIRST_ACADEMIC_YEAR,
	currentAcademicStartYear()
).map((year) => ({
	label: `${year}-${year + 1}`,
	value: `${year}-${year + 1}`,
}));

export const years = range(FIRST_YEAR, new Date().getFullYear()).map((year) => ({
	label: `${year}`,
	value: `${year}`,
}));

export const studentYear = [
	{ label: 100, value: 1 },
	{ label: 200, value: 2 },
	{ label: 300, value: 3 },
	{ label: 400, value: 4 },
];

export const semesters = [
	{ label: "Semester 1", value: 1 },
	{ label: "Semester 2", value: 2 },
];
